import React from 'react';

import { pure } from 'recompose';

import { css } from 'glamor';

type Props = {
  children: React.Element,
  condensed: boolean,
};

const Container = ({ children, condensed = false }: Props) =>
  <div
    {...css({
      padding: condensed ? '8px 16px' : '16px 16px',
      '@media (min-width: 701px)': {
        padding: condensed ? '8px 7.5vw' : '16px 7.5vw',
      },
    })}>
    {children}
  </div>;

export default pure(Container);



// WEBPACK FOOTER //
// ../src/client/components/layout/Container.js